import { Component, Input, Output, EventEmitter } from "@angular/core";
import { LanguageService } from "../../services/language.service";
import { Task } from "./task.model";

@Component({
  selector: "app-draggable",
  templateUrl: "./draggable.component.html",
  styleUrls: ["./draggable.component.css"]
})
export class DraggableComponent {
  @Input() height: number;
  @Input() group: string;
  @Input() tasks: Task[] = [];
  @Input() showMore = true;

  @Output() moreButtonMouseEntered = new EventEmitter<Task>();
  @Output() moreButtonMouseLeft = new EventEmitter<void>();
  @Output() manualButtonClicked = new EventEmitter<Task>();

  constructor(public languageService: LanguageService) {}

  onListDragStart(e: any) {
    e.cancel = true;
  }

  onItemDragStart(e: any) {
    e.itemData = e.fromData;
  }

  onItemDragEnd(e: any) {
    if (e.toData) { e.cancel = true; }
  }
}
